module.exports = __webpack_public_path__ + "img/related_services_black_icon.c8733968.svg";